

import React, {
    useState
} from 'react';
import { Link, useLocation } from "react-router";

import config from "../config/config";
import LogoutButton from '../components/logout-button';
import ArrowIcon from '../svg/arrow'

const is_disclosure = window.matchMedia("(max-width: 75em)").matches;

const AccountNavigation = () => {

    const [disclosureOpen, setDisclosureOpen] = useState(false);
    const location = useLocation();

    return (
        <nav className="account-navigation">

            {is_disclosure &&
                <button type="button" 
                        className='account-navigation__disclosure-button' 
                        onClick={() => setDisclosureOpen(!disclosureOpen)} 
                        aria-expanded={disclosureOpen} 
                        aria-controls="accountNavigationPanel">
                            Your Account
                            <ArrowIcon />
                </button>
            }
            <div id="accountNavigationPanel" className="account-navigation__disclosure-panel" {...(is_disclosure ? {hidden: !disclosureOpen, "aria-hidden": !disclosureOpen} : {})}>
                <ul className='account-navigation__list' role="list">
                    {config.ACCOUNT_AREAS?.map(area => {
                        const pathname = location.pathname.replace(/\/$/, "");
                        return (
                        <li key={area.link}>
                            <Link to={area.link} className={pathname == area.link ? 'active' : ''}>{area.title}</Link>
                        </li>
                    )})}
                </ul>
                <LogoutButton />
            </div>
        </nav>
    );
};

export default AccountNavigation;
